import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { enumMapper, FeatureFlag, JobSource, JobState, JobType, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { JobDetailsModalComponent, JobModalComponent, } from '@pages/jobs/modals';
import { FileDownloadService, JobService, ProcessService, SignalRService, } from '@services';
import { BehaviorSubject, of, } from 'rxjs';
import { filter, map, switchMap, takeUntil, } from 'rxjs/operators';
var ɵ0 = urlStateHandler;
var JobsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JobsPageComponent, _super);
    function JobsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.JobSource = JobSource;
        _this.JobType = JobType;
        _this.JobState = JobState;
        _this.stateList = enumMapper(JobState, {
            resourceKey: 'JobState',
        });
        _this.sourceList = enumMapper(JobSource, {
            resourceKey: 'JobSource',
        });
        _this.disableDetails$ = new BehaviorSubject(false);
        _this.isLicenseInvalid$ = _this._appState.user.license.value$
            .pipe(map(function (license) { return license.isExpired; }));
        _this.isManualRestartFeatureEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.ManuallyRestartJob);
        _this._route = _this._injector.get(ActivatedRoute);
        _this._signalR = _this._injector.get(SignalRService);
        _this._jobService = _this._service;
        _this._processService = _this._injector.get(ProcessService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        _this._updateJobState = function (message) {
            if (message.isNew &&
                _this._grid.footer.state.pageIndex === 0) {
                _this._refresh$.next();
            }
            else {
                _this._grid.dataManager.patchRow(message.jobId, tslib_1.__assign({ state: message.state, startTime: message.startTime, endTime: message.endTime }, !message.robotName ? { robot: undefined } :
                    {
                        robot: {
                            name: message.robotName,
                        },
                    }));
            }
        };
        _this._fetchProcessAndJob = function (job) {
            return !!job
                ? _this._processService
                    .getInstance(job.release.id)
                    .pipe(
                // we need to fetch the associated robot because
                // signalr updates don't include the robot id
                switchMap(function () { return _this._jobService.getInstance(job.id, ['Robot', 'Release']); }), takeUntil(_this._destroyed$))
                : of(undefined);
        };
        return _this;
    }
    Object.defineProperty(JobsPageComponent.prototype, "isMediaRecordingEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.MediaRecording);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobsPageComponent.prototype, "allowCancel", {
        get: function () {
            var _this = this;
            return this._grid.selectionManager.hasValue()
                && this._grid.selectionManager.selected.every(function (job) {
                    return _this.isCancellingAllowed(job);
                });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JobsPageComponent.prototype, "allowTerminate", {
        get: function () {
            var _this = this;
            return this._grid.selectionManager.hasValue()
                && this._grid.selectionManager.selected.every(function (job) {
                    return _this.isTerminationAllowed(job);
                });
        },
        enumerable: true,
        configurable: true
    });
    JobsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._signalR.watchNewJobs();
        this._signalR
            .jobs$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(this._updateJobState);
        this._expand$.next(['Robot', 'Release']);
        this.data$
            .subscribe(function (jobs) { return _this._signalR.watchJobs(jobs.map(function (job) { return job.id; })); });
        this._route.paramMap
            .pipe(map(function (paramMap) { return parseInt(paramMap.get('id'), 10); }), filter(function (id) { return !isNaN(id); }), takeUntil(this._destroyed$))
            .subscribe(function (id) {
            _this._filters$.next([{
                    value: id,
                    property: 'startingTriggerId',
                    method: 'eq',
                }]);
        });
        this.isCurrentFolderClassic$ = this._appState.user.folder.isClassic$;
    };
    JobsPageComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._signalR.watchJobs(false);
        this._signalR.watchNewJobs(false);
    };
    JobsPageComponent.prototype.openModal = function (job) {
        var _this = this;
        this._fetchProcessAndJob(job)
            .pipe(switchMap(function (completeJob) {
            return _this._modal
                .openModal(JobModalComponent, completeJob, { size: 'lg' })
                .afterClosedResult();
        })).subscribe(function () { return _this._refresh$.next(); });
    };
    JobsPageComponent.prototype.showDetails = function (job) {
        var _this = this;
        this.disableDetails$.next(true);
        this._jobService
            .getInstance(job.id, ['Robot', 'Release'])
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (jobDetails) {
            _this._modal.openModal(JobDetailsModalComponent, jobDetails);
            _this.disableDetails$.next(false);
        });
    };
    JobsPageComponent.prototype.stopJob = function (kill, job) {
        var _this = this;
        this._modal.onConfirm(null, function () {
            var singleAction = job != null;
            var serviceCall$ = singleAction ?
                _this._jobService
                    .stopJob(job.id, kill) :
                _this._jobService
                    .stopJobs(_this._grid.selectionManager.selected.map(function (j) { return j.id; }), kill);
            serviceCall$.subscribe(function () { return _this._grid.selectionManager.clear(); });
        }, function () { }, this._translate.instant(kill ? 'jobs_confirm_kill_message' : 'jobs_confirm_stop_message'));
    };
    JobsPageComponent.prototype.isResumeAllowed = function (job) {
        return job.state === JobState[JobState.Suspended] && job.type !== JobType[JobType.Attended];
    };
    JobsPageComponent.prototype.resumeJob = function (job) {
        var _this = this;
        this._modal.onConfirm(null, function () {
            _this._jobService
                .resumeJob(job.key)
                .subscribe(function () { return _this._grid.selectionManager.clear(); });
        }, function () { }, this._translate.instant('jobs_confirm_resume_message'));
    };
    JobsPageComponent.prototype.isCancellingAllowed = function (job) {
        return [JobState.Pending, JobState.Running, JobState.Suspended, JobState.Resumed]
            .map(function (js) { return JobState[js]; })
            .indexOf(job.state) >= 0 &&
            job.type !== JobType[JobType.Attended];
    };
    JobsPageComponent.prototype.isTerminationAllowed = function (job) {
        return [JobState.Pending, JobState.Running, JobState.Stopping, JobState.Suspended, JobState.Resumed]
            .map(function (js) { return JobState[js]; })
            .indexOf(job.state) >= 0 &&
            job.type !== JobType[JobType.Attended];
    };
    JobsPageComponent.prototype.isRestartAllowed = function (job) {
        return [JobState.Faulted, JobState.Successful, JobState.Stopped]
            .map(function (js) { return JobState[js]; })
            .indexOf(job.state) >= 0 &&
            job.sourceType !== JobSource[JobSource.Agent];
    };
    JobsPageComponent.prototype.downloadRecording = function (job) {
        this._downloadService.download(this._jobService.getMediaDownloadUrl(job));
    };
    return JobsPageComponent;
}(ODataGridComponent));
export { JobsPageComponent };
export { ɵ0 };
